import React from 'react'

import { CssVars } from '../themes'
import { ThemeProvider, useTheme } from './ThemeProvider'

type Props = {
  children?: React.ReactNode
  'data-testid'?: string
}

export function ModalBackdrop(props: Props) {
  const { children } = props
  const theme = useTheme()
  return (
    <ThemeProvider theme={theme}>
      {({ rootClassName }) => (
        <div
          className={rootClassName}
          css={{
            alignItems: 'flex-start',
            backgroundColor: `rgba(0, 0, 0, 0.6)`,
            bottom: '0',
            display: 'flex',
            justifyContent: 'center',
            left: 0,
            overflow: 'auto',
            position: 'fixed',
            right: 0,
            top: 0,

            // NOTE(jare): cast as any since we're using css variables and
            // emotion expects a number for z-index
            zIndex: CssVars.size._experimentalModalZIndex as any,
          }}
          data-testid={props['data-testid']}
        >
          {children}
        </div>
      )}
    </ThemeProvider>
  )
}
